document.addEventListener('DOMContentLoaded', function () {
    const orderForm = document.getElementById('order-form');
    const cart = localStorage.getItem('cart');
    const address = localStorage.getItem('address');

    const productsField = document.querySelector('input[placeholder="Products"]');
    const hasCart = cart && productsField;

    const postalcodeField = document.querySelector('input[placeholder="Postcode"]');
    const cityField = document.querySelector('input[placeholder="Stad"]');
    const countryField = Array.from(document.querySelectorAll('select')).find((select) => select.value === 'Nederland');
    const hasAddress = address && postalcodeField && cityField && countryField;

    const firstNameField = document.querySelector('input[placeholder="Voornaam"]');
    const lastNameField = document.querySelector('input[placeholder="Achternaam"]');
    const companyNameField = document.querySelector('input[placeholder="Bedrijfsnaam"]');
    const streetAddressField = document.querySelector('input[placeholder="Adres"]');
    const streetAddressAdditionField = document.querySelector('input[placeholder="Adres toevoeging"]');
    const phoneNumberField = document.querySelector('input[placeholder="Telefoon"]');
    const emailAddressField = document.querySelector('input[placeholder="E-mailadres"]');

    const changeOrderButton = document.getElementById('changeOrderButton');
    const orderThanks = document.getElementById('order-thanks');

    function setFieldValue(field, storageKey) {
        const savedValue = localStorage.getItem(storageKey);
        if (savedValue && field) {
            field.value = savedValue;
        }
    }

    function saveFormState() {
        const fields = [
            { field: firstNameField, key: 'firstName' },
            { field: lastNameField, key: 'lastName' },
            { field: companyNameField, key: 'companyName' },
            { field: streetAddressField, key: 'streetAddress' },
            { field: streetAddressAdditionField, key: 'streetAddressAddition' },
            { field: phoneNumberField, key: 'phoneNumber' },
            { field: emailAddressField, key: 'emailAddress' },
        ];

        fields.forEach(({ field, key }) => {
            if (field) {
                localStorage.setItem(key, field.value);
            }
        });
    }

    setFieldValue(firstNameField, 'firstName');
    setFieldValue(lastNameField, 'lastName');
    setFieldValue(companyNameField, 'companyName');
    setFieldValue(streetAddressField, 'streetAddress');
    setFieldValue(streetAddressAdditionField, 'streetAddressAddition');
    setFieldValue(phoneNumberField, 'phoneNumber');
    setFieldValue(emailAddressField, 'emailAddress');

    if (orderForm && hasCart && hasAddress) {
        let parsedCart = [...JSON.parse(cart)];
        let parsedAddress = JSON.parse(address);

        parsedCart = parsedCart.map((product) => {
            return { ProductKey: product.id, Amount: product.amount };
        });

        productsField.value = JSON.stringify(parsedCart);

        postalcodeField.value = parsedAddress.postalcode;
        postalcodeField.readOnly = true;
        cityField.value = parsedAddress.city;
        cityField.readOnly = true;
        countryField.value = parsedAddress.country;
        countryField.disabled = true;
    }

    if (changeOrderButton) {
        changeOrderButton.addEventListener('click', function () {
            saveFormState();
            window.location.href = '/winkelwagen';
        });
    }

    function priceExBtw(price) {
        return (price / 121 * 100).toFixed(2);
    }

    function clearOrderData() {
        localStorage.removeItem('orderPlaced');
        localStorage.removeItem('cart');
        localStorage.removeItem('address');
        localStorage.removeItem('cost');
        localStorage.removeItem('new');

        localStorage.removeItem('firstName');
        localStorage.removeItem('lastName');
        localStorage.removeItem('companyName');
        localStorage.removeItem('streetAddress');
        localStorage.removeItem('streetAddressAddition');
        localStorage.removeItem('phoneNumber');
        localStorage.removeItem('emailAddress');
    }

    if (orderThanks) {
        localStorage.setItem('orderPlaced', true);
        // order placed
        var transactionId = orderThanks.dataset.factuurnummer;
        if (transactionId == "" || transactionId == "0") {
            return;
        } else {

        var dataLayerItems = [];
        this.cart = JSON.parse(localStorage.getItem('cart'));
        this.cost = JSON.parse(localStorage.getItem('cost'));



        this.cart.forEach((item) =>
            dataLayerItems.push({
                "item_id": item.id,
                "item_name": item.name,
                "price": priceExBtw(item.price),
                "quantity": item.amount
            })
        );
        dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
        dataLayer.push({
            event: "purchase",
            ecommerce: {
                transaction_id: transactionId,
                // Sum of (price * quantity) for all items.
                value: priceExBtw(this.cost.subtotal),
                tax: (this.cost.subtotal - priceExBtw(this.cost.subtotal)).toFixed(2),
                shipping: this.cost.shipping,
                currency: "EUR",
                items: dataLayerItems
            }
        });
        }

    } else {
        let orderPlaced = localStorage.getItem('orderPlaced');
        if (orderPlaced) {
            clearOrderData();
        }
    }

});
